/**
 * 统一 API 错误类
 *
 * 由 src/utils/httpClient.ts 与 ledger-ai-app/src/services/request.ts
 * 的响应拦截器在「业务码非 200」或「业务错误」时抛出。
 * 取代旧的 ApiResponse<{success:false, error:string}> 形态。
 */

/** 个人空间限制错误码（需要触发创建组织提示） */
export const PERSONAL_SPACE_ERROR_CODES = [4401, 4402, 4403, 4404] as const

export type PersonalSpaceErrorCode = (typeof PERSONAL_SPACE_ERROR_CODES)[number]

export class ApiError extends Error {
  /** 业务错误码：0/-1 表示网络/HTTP 错误，>0 表示业务码 */
  public readonly code: number

  constructor(code: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
  }

  /** 是否为个人空间限制错误 */
  isPersonalSpaceLimit(): boolean {
    return (PERSONAL_SPACE_ERROR_CODES as readonly number[]).includes(this.code)
  }
}
